import React from 'react'
import {
  Container, Row, Col, CardText, CardBody,
  CardTitle
} from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import { getSelectedStateInfo } from '../redux/reducers'
import apiService from '../utils/apiService'

const graphic = '/assets/start-step-graphic.svg'

function Slide9 ({ onNextRequested, formProps, onExitRequested }) {
  onExitRequested = () => {
    window.location.href = `${formProps.exitLink}`
  }
  return (
    <CardBody className='app-slide Slide9 w-100'>
      <Container fluid>
        <Row>
          <Col xs={{ size: 12, order: 2 }} xl={{ size: 6, offset: 1 }} className='content-col'>
            <CardTitle className='pb-2'><h2>Thank you!</h2>
            </CardTitle>
            <CardText className='pb-2'>Southern Farm Bureau Insurance Company provides life insurance coverage in your state through {formProps.recommendedTier}. To learn more visit <a href={formProps.exitLink}>{formProps.exitLinkDisplay}</a>. </CardText>
            <CardText>A local {formProps.bureauAgentDisplay} agent will be contacting you soon.</CardText>
            <a
              className='btn btn-end'
              target='_blank'
              rel='noopener noreferrer'
              href={formProps.exitLink}
            >VISIT {formProps.exitLinkDisplay.toUpperCase()}</a>
          </Col>
          <Col xs={{ size: 12, order: 1 }} xl={5}>
            <img src={graphic} alt='How much life insurance is right for you?' />
          </Col>
        </Row>
      </Container>
    </CardBody>
  )
}

const mapStateToProps = (state, props) => ({
  formProps: {
    recommendedTier: getSelectedStateInfo(state.app.state).tier,
    exitLink: getSelectedStateInfo(state.app.state).url,
    exitLinkDisplay: getSelectedStateInfo(state.app.state).url.replace('https://www.', ''),
    bureauAgentDisplay: getSelectedStateInfo(state.app.state).tier.replace('Insurance', ''),
    generatedPdfFilename: state.app.generatedPdfFilename
  },
  apiService: apiService
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide9)
